module.exports = __webpack_public_path__ + "static/img/order-yes-01.3f6a4cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/order-yes-01.jpg
// module id = 282
// module chunks = 1